import React from 'react';

/**
 * Logged-in: initial dual choice (profile vs upload), then profile banner or upload hint with link back.
 * Not rendered when logged out (parent shows upload only).
 */
export default function ResumeProfileResumeSource({
  loggedIn,
  /** 'pick' | 'profile' | 'upload' (caller should pass logged-out users as implicit 'upload' for zone logic only). */
  resumeSource,
  profileResumeLoading,
  fileName,
  disableActions,
  onPickProfileResume,
  onPickUploadResume,
  onChooseFileUploadInstead,
  onBackToResumeChoices,
}) {
  if (!loggedIn) return null;

  if (resumeSource === 'pick') {
    return (
      <div className="resume-subpage__resume-choice">
        <div className="resume-subpage__resume-choice-buttons">
          <button
            type="button"
            className="resume-subpage__submit"
            onClick={onPickProfileResume}
            disabled={disableActions || profileResumeLoading}
          >
            {profileResumeLoading ? 'Loading profile resume…' : 'Use my profile resume'}
          </button>
          <button
            type="button"
            className="resume-subpage__submit"
            onClick={onPickUploadResume}
            disabled={disableActions || profileResumeLoading}
          >
            Upload a resume file
          </button>
        </div>
      </div>
    );
  }

  if (resumeSource === 'profile') {
    return (
      <div className="resume-subpage__profile-source">
        <div className="resume-subpage__profile-source-active" role="status">
          <span className="resume-subpage__profile-source-label">
            Using resume from profile: <strong>{fileName || '—'}</strong>
          </span>
          <button
            type="button"
            className="resume-subpage__submit resume-subpage__profile-source-switch"
            onClick={onChooseFileUploadInstead}
            disabled={disableActions}
          >
            Upload a file instead
          </button>
        </div>
      </div>
    );
  }

  /* upload — path back to dual choice */
  return (
    <div className="resume-subpage__profile-source resume-subpage__profile-source--upload-hint">
      <button
        type="button"
        className="resume-subpage__submit"
        onClick={onBackToResumeChoices}
        disabled={disableActions}
      >
        Use my profile resume instead
      </button>
    </div>
  );
}
